class ItemFormularioCampoTipo {
    Id: string;
    Nombre: string;
    RequiereLista: boolean;
    SoloLectura: boolean;

    constructor() {
        this.Id = "";
        this.Nombre = "";
        this.RequiereLista = false;
        this.SoloLectura = false;
    };
};

const ItemFormularioCampoTipos : ItemFormularioCampoTipo[] = [
    {
        Id: "CAB",
        Nombre: "Cabecera",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "EML",
        Nombre: "Email",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "PWD",
        Nombre: "Contraseña",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "TLF",
        Nombre: "Teléfono",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "SLN",
        Nombre: "Texto línea simple",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "MLN",
        Nombre: "Texto multilínea",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "NUM",
        Nombre: "Numérico",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "FEC",
        Nombre: "Fecha",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "HOR",
        Nombre: "Hora",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "FHO",
        Nombre: "Fecha y hora",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "LSU",
        Nombre: "Lista selección única",
        RequiereLista: true,
        SoloLectura: false,
    },
    {
        Id: "LSM",
        Nombre: "Lista selección múltiple",
        RequiereLista: true,
        SoloLectura: false,
    },
    {
        Id: "TSL",
        Nombre: "Texto sólo lectura",
        RequiereLista: false,
        SoloLectura: true,
    },
    {
        Id: "SWC",
        Nombre: "Botón switch",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "SLD",
        Nombre: "Slider",
        RequiereLista: false,
        SoloLectura: false,
    },
    {
        Id: "CHK",
        Nombre: "CheckBox",
        RequiereLista: false,
        SoloLectura: false,
    },
];

export { ItemFormularioCampoTipo, ItemFormularioCampoTipos };
